import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { IPropsSafraEmissao } from '../../../@types/CarteiraCreditoProps';

interface IPropsSafra {
  data: IPropsSafraEmissao[];
}

export const SafraEmissao = ({ data = [] }: IPropsSafra) => {
  if (!data || data.length === 0) {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: '1rem 0',
          color: '#6B7280',
          fontSize: '0.875rem',
        }}
      >
        Sem dados de carteira de crédito para este fundo.
      </div>
    );
  }

  // ano === null identifica papéis sem código legível de emissão: sempre por último.
  const sorted = [...data].sort((a, b) => {
    if (a.ano === null) return 1;
    if (b.ano === null) return -1;
    return a.ano - b.ano;
  });

  const categories = sorted.map((item) =>
    item.ano === null ? 'Sem código' : String(item.ano)
  );

  const series = [
    {
      name: '% da carteira',
      data: sorted.map((item) => Number(item.percentual) || 0),
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '55%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['#EC6643'],
    xaxis: {
      categories,
    },
    yaxis: {
      labels: {
        formatter: (val: number) => `${val.toFixed(0)}%`,
      },
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val.toFixed(2).replace('.', ',')}%`,
      },
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height={180}
    />
  );
};
